<div class="flex flex-col flex-1 w-full h-full bg-gray-100 font-sans overflow-y-auto custom-scrollbar">
  <div class="flex-1 flex items-center justify-center w-full p-6 lg:p-12">
    <div class="bg-white p-10 lg:p-12 rounded-xl shadow-lg w-full max-w-[440px] lg:max-w-[500px] text-center mx-auto transition-all">
      <!-- Language Switcher -->
      <div class="flex justify-end gap-3 mb-4 text-[0.75rem] font-semibold text-gray-400">
        @for (lang of languages; track lang) {
        <span class="cursor-pointer transition-colors duration-200 hover:text-blue-600"
          [class.text-blue-600]="ts.currentLang() === lang"
          [class.underline]="ts.currentLang() === lang"
          [class.underline-offset-4]="ts.currentLang() === lang"
          (click)="ts.setLanguage(lang)">
          {{ lang.toUpperCase() }}
        </span>
        }
      </div>

      <!-- Error Messages -->
      @if (errorMessage()) {
      <div class="p-3 px-4 rounded mb-6 text-sm text-left bg-red-100 text-red-800 border border-red-700">
        {{ errorMessage() }}
      </div>
      }

      <!-- Success Messages -->
      @if (successMessage()) {
      <div class="p-3 px-4 rounded mb-6 text-sm text-left bg-green-100 text-green-800 border border-green-700">
        {{ successMessage() }}
      </div>
      }

      <h2 class="text-gray-800 mb-2 text-2xl font-bold">{{ ts.t('login_title') }}</h2>
      <form class="mt-6 text-left space-y-4" (submit)="onLogin(); $event.preventDefault()">
        <div class="space-y-1">
          <label for="username" class="block font-medium text-gray-600">
            {{ ts.t('label_username') }}:
          </label>
          <input type="text" id="username" [value]="username()" (input)="onUsernameChange($any($event.target).value)"
            [placeholder]="ts.t('placeholder_username')" [disabled]="isLoading()" required 
            class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors" />
        </div>

        <div class="space-y-1">
          <label for="password" class="block font-medium text-gray-600">
            {{ ts.t('label_password') }}:
          </label>
          <input type="password" id="password" [value]="password()"
            (input)="onPasswordChange($any($event.target).value)" [placeholder]="ts.t('placeholder_password')"
            [disabled]="isLoading()" required 
            class="w-full p-3 border border-gray-300 rounded focus:outline-none focus:border-blue-600 transition-colors" />
        </div>

        <button type="submit" [disabled]="isLoading() || retryTimer() > 0"
          class="w-full p-3 mt-4 bg-blue-600 text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed">
          @if (isLoading()) {
          <span class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full font-sans"></span>
          }
          @if (retryTimer() > 0) {
          {{ ts.t('msg_wait', { seconds: retryTimer() }) }}
          } @else {
          {{ ts.t('btn_signin') }}
          }
        </button>
      </form>

      <div class="mt-6 text-sm text-gray-500 flex justify-center items-center gap-2">
        <a (click)="navigateToExtAuth('forgot-password')" class="text-blue-600 hover:underline cursor-pointer transition-all">{{ ts.t('link_forgot_password') }}</a>
        <span class="text-gray-300"> | </span>
        <a (click)="navigateToExtAuth('register')" class="text-blue-600 hover:underline cursor-pointer transition-all">{{ ts.t('link_request_account') }}</a>
      </div>

      <div class="my-6 border-t border-gray-100 relative">
        <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-4 text-gray-400 text-sm italic">
          {{ ts.t('text_or') }}
        </span>
      </div>

      <button type="button" (click)="onAzureLogin()" [disabled]="isLoading()"
        class="w-full p-3 bg-[#2f2f2f] text-white border-0 rounded font-semibold transition-colors flex items-center justify-center gap-2 hover:bg-black">
        @if (isLoading()) {
        <span class="animate-spin h-5 w-5 border-2 border-white border-t-transparent rounded-full font-sans"></span>
        }
        {{ ts.t('btn_vantage_login') }}
      </button>

      <div class="my-6 border-t border-gray-100 relative">
        <span class="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white px-4 text-gray-400 text-sm italic">
          {{ ts.t('text_or') }}
        </span>
      </div>

      <button type="button" disabled
        class="w-full p-3 bg-gray-50 text-gray-400 border border-dashed border-gray-300 rounded font-semibold cursor-not-allowed">
        {{ ts.t('text_coming_soon') }}
      </button>
    </div>
  </div>
  <app-footer></app-footer>
</div>